module.exports = __webpack_public_path__ + "img/image10.3ba8ba25.png";